/**
 * Copyright © 2026 Adnuntius AS.
 */

const NETWORK_EXPLORE_USERNAME = 'adnuntius@adnuntius.com';

export function canAccessNetworkExplore(localUserProfile: any, localUserPermissions: any): boolean {
  const app = localUserProfile.getCurrentApp();
  const sectionPerms = localUserPermissions.getSectionPerms(app);
  return localUserProfile.get('username') === NETWORK_EXPLORE_USERNAME && sectionPerms.explore === true;
}
